import {Col, Row} from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {POSFilterTitleProps} from './props'
import {CLEAR_FILTER, CLOSE_FILTER} from '@/constants/playwright-ids'

export const FilterTitle: React.FC<POSFilterTitleProps> = ({onClearFilters}) => {
    const { t } = useTranslation()
    return (
        <Row justify={'space-between'}>
            <Col>
                <span>{t('FilterTitle.filters')}</span>
            </Col>
            <Col>
                <a
                    href="#"
                    onClick={onClearFilters}
                    data-test-id={CLEAR_FILTER}
                >{t('FilterTitle.clearFilter')}</a>
            </Col>
        </Row>
    )
}
